// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Af y5","wrapperNeon":"Ah zf","ribbon":"Ai zc","title":"Aj y7","seasons":"Ak za","genres":"Al zb","buttonWrapper":"Am y9","button":"An y-","buttonNeon":"Ao zh"};